function detectOsFamily(): string {
  if (typeof navigator === 'undefined') {
    return 'other';
  }
  const ua = navigator.userAgent.toLowerCase();
  if (/iphone|ipad|ipod/.test(ua) || (/macintosh/.test(ua) && navigator.maxTouchPoints > 1)) {
    return 'ios';
  }
  if (/android/.test(ua)) {
    return 'android';
  }
  return 'other';
}

export function buildWebFingerprint(): string {
  if (typeof window === 'undefined') {
    return '';
  }
  const lang = (navigator.language || 'unknown').toLowerCase();
  const tz = Intl.DateTimeFormat().resolvedOptions().timeZone || 'unknown';
  const scale = Number(window.devicePixelRatio.toFixed(2)).toString();
  const edges = [screen.width, screen.height]
    .map((edge) => Math.round(edge * window.devicePixelRatio))
    .sort((left, right) => left - right);
  return `v2|${detectOsFamily()}|${lang}|${tz}|${edges[0]}x${edges[1]}|${scale}`;
}
